import React from "react";

// export const Logo: React.FC<{ size?: number }> = ({ size = 36 }) => (
//   <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
//     <defs>
//       <linearGradient id="tkn-lg" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
//         <stop offset="0%"   stopColor="#00c896" />
//         <stop offset="100%" stopColor="#007a5e" />
//       </linearGradient>
//     </defs>
//     <rect width="100" height="100" rx="22" fill="url(#tkn-lg)" />
//     <rect x="43" y="32" width="14" height="40" rx="7" fill="white" />
//     <rect x="27" y="32" width="46" height="14" rx="7" fill="white" />
//     <rect x="46" y="10" width="8" height="16" rx="4" fill="white" opacity=".9" />
//     <rect x="46" y="10" width="8" height="16" rx="4" fill="white" opacity=".85" transform="rotate(45 50 50)"  />
//     <rect x="46" y="10" width="8" height="16" rx="4" fill="white" opacity=".85" transform="rotate(-45 50 50)" />
//     <rect x="46" y="10" width="8" height="16" rx="4" fill="white" opacity=".7"  transform="rotate(90 50 50)"  />
//     <rect x="46" y="10" width="8" height="16" rx="4" fill="white" opacity=".65" transform="rotate(-90 50 50)" />
//   </svg>
// );
export const Logo: React.FC<{ size?: number }> = ({ size = 36 }) => (
	<svg
		id="Layer_1"
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		viewBox="0 0 2267.7 706.4">
		<g>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M449.5,289.9h-126.2c-14.7,0-24.2,9.5-24.2,24.2s9.5,24.2,24.2,24.2h31.6l-50.5,188.5c-.7,2.4-1,4.7-1,6.8,0,6.4,2.6,12.2,7.5,16.9,4.7,4.5,10.6,6.9,16.9,6.9,11.3,0,20-6.6,23.2-17.9l54.1-201.3h44.5c14.7,0,24.2-9.5,24.2-24.2s-9.5-24.2-24.2-24.2Z"
			/>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M648.1,289.9h-97.2c-14.1,0-24.2,7.7-27.7,21.1l-58.8,218.9c-2.1,7-.9,13.9,3.3,19.3,4.1,5.3,10.4,8.3,17.6,8.3h104.1c14.7,0,24.2-9.5,24.2-24.2s-9.5-24.2-24.2-24.2h-69.2l19.7-73.4h57c14.7,0,24.2-9.5,24.2-24.2s-9.5-24.2-24.2-24.2h-44.1l13.1-49h82.1c14.7,0,24.2-9.5,24.2-24.2s-9.5-24.2-24.2-24.2Z"
			/>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M866.8,289.9c-5.6,0-11,2-15.4,5.7l-103.5,85.6,16.2-60.5c.6-2,.8-4.2.8-6.8,0-14.6-9.5-24-24.2-24s-20.3,6.7-23.2,17.9l-58.9,219c-.7,2.4-1,4.7-1,6.8,0,6.4,2.6,12.2,7.5,16.9,4.7,4.5,10.6,6.9,16.9,6.9,11.3,0,20-6.6,23.2-17.9l21-77.9,27.5-22.7,31.2,101.2c3.2,10.8,11.9,17.3,23.1,17.3s24.2-9.4,24.2-24-.4-5-1.1-7.4l-37-120.6,88-72.8c5.7-4.8,8.8-11.2,8.8-18.6,0-14.7-9.5-24.2-24.2-24.2Z"
			/>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M1085.2,289.9c-11.6,0-20.3,6.7-23.2,17.9l-37.1,138.1-42.6-139c-3.2-10.6-11.9-17-23.1-17s-20.3,6.7-23.2,17.9l-58.9,219c-.7,2.4-1,4.7-1,6.8,0,6.4,2.6,12.2,7.5,16.9,4.7,4.5,10.6,6.9,16.9,6.9,11.3,0,20-6.6,23.2-17.9l37.1-137.9,42.4,138.5c3.2,10.8,11.9,17.3,23.3,17.3s20-6.6,23.2-17.9l58.8-218.9c.6-2,.8-4.2.8-6.8,0-14.6-9.5-24-24.2-24Z"
			/>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M1295.5,289.9c-11.6,0-20.3,6.7-23.2,18l-43.2,161.5c-2.9,10.7-9.4,19.9-19.9,27.9-10.6,8-21.1,11.9-32.1,11.9s-14.4-2.3-19.6-7.1c-5-4.6-7.3-10.3-7.3-17.9s.4-5.4,1.3-8.5l41.5-154.8c.6-2,.8-4.2.8-6.8,0-14.6-9.5-24-24.2-24s-20.3,6.7-23.2,17.9l-43.4,161.5c-1.2,4.7-1.9,9.8-1.9,15.1,0,18.3,6.8,35,20.3,49.8,14.1,15.5,30.6,23.3,49.1,23.3s48.8-7.4,67.9-21.9c19.1-14.6,32.3-34.8,39.1-60.1l41.5-154.8c.6-2,.8-4.2.8-6.8,0-14.6-9.5-24-24.2-24Z"
			/>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M1424.6,509.1h-69.2l50.5-188.4c.6-2,.8-4.2.8-6.8,0-14.6-9.5-24-24.2-24s-20.3,6.7-23.2,17.9l-59.7,222.2c-2,7.2-.8,14.1,3.4,19.4,4.1,5.2,10.3,8.1,17.6,8.1h104.1c14.7,0,24.2-9.5,24.2-24.2s-9.5-24.2-24.2-24.2Z"
			/>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M1661.2,289.9c-11.6,0-20.3,6.7-23.2,18l-43.2,161.5c-2.9,10.7-9.4,19.9-19.9,27.9-10.6,8-21.1,11.9-32.1,11.9s-14.4-2.3-19.6-7.1c-5-4.6-7.3-10.3-7.3-17.9s.4-5.4,1.3-8.5l41.5-154.8c.6-2,.8-4.2.8-6.8,0-14.6-9.5-24-24.2-24s-20.3,6.7-23.2,17.9l-43.4,161.5c-1.2,4.7-1.9,9.8-1.9,15.1,0,18.3,6.8,35,20.3,49.8,14.1,15.5,30.6,23.3,49.1,23.3s48.8-7.4,67.9-21.9c19.1-14.6,32.3-34.8,39.1-60.1l41.5-154.8c.6-2,.8-4.2.8-6.8,0-14.6-9.5-24-24.2-24Z"
			/>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M1866.1,289.9h-72.3c-14.8,0-28.6,2.6-40.9,7.8-25.1,10.8-41.9,31.7-50,62l-32.7,121.8c-1.1,4.2-1.7,8.7-1.7,13.3,0,10.2,2.8,20.3,8.4,30,15.5,27.1,36.5,32.8,51.4,32.8h75.7c13.9,0,24-7.7,27.7-21.1l32.7-122c.4-1.6.5-3.3.5-6.2,0-12.5-8.7-20.9-21.6-20.9h-41.3c-14.7,0-24.2,9.5-24.2,24.2s9.5,24.2,24.2,24.2h6.6l-19.7,73.4h-53.9c-5.4,0-9.5-1.4-12.9-4.5-3.1-2.8-4.4-6.1-4.4-11s.3-3.8.9-5.9l32.9-121.8c1.3-4.9,3.7-9.4,7.3-13.8,7.9-9.3,17.2-13.8,28.5-13.8h79c14.7,0,24.2-9.5,24.2-24.2s-9.5-24.2-24.2-24.2Z"
			/>
			<path
				className="st1"
				style={{ fill: "#06a384" }}
				d="M2110.2,296.6h0c-4.7-4.4-10.6-6.7-16.9-6.7s-12.5,2.6-17.2,7.6l-79.8,83.1-31.9-75.9c-4.1-9.4-12.2-14.8-22.3-14.8-14.7,0-24.2,9.5-24.2,24.2s.6,6.5,1.9,9.5l43.1,102.1-27.2,101.4c-.6,2.4-1,4.6-1,6.6,0,6.7,2.8,12.7,8,17.3,4.8,4.3,10.7,6.5,16.9,6.5,11.3,0,19.9-6.7,22.9-18l27.8-103.9,100.7-104.9c4.5-4.7,6.8-10.5,6.8-16.9s-2.6-12.7-7.6-17.3Z"
			/>
		</g>
		<g>
			<path
				className="st0"
				style={{ fill: "#016068" }}
				d="M272.1,323.2c0-11.2-7.6-23.4-22.4-25.2-13.8-1.7-65.5-2.2-80.2.3-9.3,1.8-12.6,6.5-16,11.7-2.5,3.9-3.9,8.4-3.9,13h0c0,6.7,2.8,13.2,7.8,17.6,12.3,10.8,28.4,8.9,50.8,9.2,28.3-.4,62.8,3.4,63.9-26.5Z"
			/>
			<path
				className="st0"
				style={{ fill: "#016068" }}
				d="M239.4,158.8c-31-6.1-38.9,25.3-21.7,45.3,14,13.9,45.4,54.6,67.7,54.6,20.7-2.9,34-20,13.3-46.8-3.1-3.9-47.9-51-59.4-53.2Z"
			/>
			<path
				className="st0"
				style={{ fill: "#016068" }}
				d="M395.4,112.7c-9.6-19.5-44.1-15.9-46.9,6.6-2.1,12.8-2.1,69.8,0,82.4,2.5,18.8,30.7,27.3,43.3,12.7h0c4.4-4.8,6.4-13.3,6.8-17.1.8-19.5,4.8-66.2-3.2-84.6Z"
			/>
			<path
				className="st0"
				style={{ fill: "#016068" }}
				d="M531.5,165.3c-7.7-9.2-27.8-9.5-36.7,0-8.6,6.3-45.3,42.9-51.1,51.6-16.6,23.4,4.3,47.1,25.5,40.9,4.1-1.2,7.7-3.7,10.7-6.7,9.3-9.3,36.9-36.8,49.6-49.6,6-6,9.4-14.4,8.2-22.9-.7-5.2-2.8-9.9-6.2-13.3Z"
			/>
			<path
				className="st0"
				style={{ fill: "#016068" }}
				d="M279.8,387.2c-5.2.9-10.5,4.5-15.4,8.4-4.2,3.3-48.9,46.6-52.4,53.4-10,17.8,1,39.1,20.8,38.9,0,0,0,0,.1,0,7.1,0,13.8-3.3,18.8-8.3l52.8-53.3c13.1-16.5-4-43.5-24.6-39.1Z"
			/>
		</g>
	</svg>
);
